<template>
  <div class="default-table company-container">
    <div class="company-list">
      <div class="head">
        <div class="divide-title">
          <span></span>
          乙方池
        </div>

        <el-button class="buttons" type="primary" size="mini" @click="handelCreate" v-if="userAuth.can_add_pt_company">
          新增乙方
        </el-button>
      </div>
      <ml-table ref="MlTable" :api="getCompanyList" :search="{}">
        <template slot="columns">
          <el-table-column label="序号" type="index" width="55" header-align="center" align="center"/>
          <el-table-column prop="name" label="公司名称" min-width="100" show-overflow-tooltip/>
          <el-table-column prop="_status" label="状态" header-align="center" align="center" width="100"
                           show-overflow-tooltip/>
          <el-table-column label="操作" header-align="center" align="center" width="120">
            <template slot-scope="{row}">
              <el-button type="text" size="mini" icon="el-icon-edit"
                         v-if="userAuth.can_update_pt_company" @click="handelUpdate(row)">修改
              </el-button>
              <el-button type="text" size="mini" icon="el-icon-delete"
                         v-if="userAuth.can_delete_pt_company" @click="handelDelete(row)">删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </ml-table>
    </div>
    <order-company-config :key="key"/>
    <el-dialog :title="dialogType==='CREATE'?'新增乙方':'编辑乙方'" :visible.sync="dialogStore" width="580px"
               center>
      <el-form label-width="80px" ref="elForm" :model="formStore" size="big" :rules="rules">
        <el-form-item prop="name" label="乙方名称">
          <el-input v-model="formStore.name" maxlength="150" clearable show-word-limit/>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="formStore.status" placeholder="请选择状态">
            <el-option value="Y" label="启用"/>
            <el-option value="N" label="禁用"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStore = false">取 消</el-button>
        <el-button type="primary" @click="handelStoreSure" :disabled="loadingSubmit"
                   :loading="loadingSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getCompanyList, createCompanyData, updateCompanyData, deleteCompanyData} from "@/api/company";
import OrderCompanyConfig from "@/views/company/components/order-company.vue";
import MlTable from "@/components/MlTable/index.vue";

const ConfigPage = {
  is_show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 30,
  page: 1,
}
const makeKey = function () {
  return new Date().getTime() + Math.random().toString(36);
}

export default {
  name: "index",
  data() {
    return {
      key: makeKey(),
      tableData: [],
      loading: false,
      configPage: ConfigPage,
      formStore: {
        id: null,
        name: null,
        status: null
      },
      dialogType: 'CREATE',
      dialogStore: false,
      rules: {
        name: [
          {required: true, message: '名称', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '状态', trigger: 'blur'},
        ]
      },
      loadingSubmit: false
    }
  },
  components: {
    MlTable,
    OrderCompanyConfig
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    getCompanyList,
    handelCreate() {
      //新增
      this.formStore = {}
      this.dialogType = 'CREATE'
      this.dialogStore = true
    },
    handelUpdate(row) {
      this.formStore = row
      this.dialogType = 'EDIT'
      this.dialogStore = true
    },
    getTableData: function () {
      this.$refs.MlTable.getTable()
      this.key = makeKey()
    },
    //删除
    async deleteRow(id) {
      await deleteCompanyData({id: id}).then(res => {
        return res.model
      })
      this.$nextTick(() => {
        this.getTableData()
      })
    },
    handelDelete(row) {
      this.$msgbox.confirm('此操作将永久删除该乙方设置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRow(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handelStoreSure() {
      let that = this

      this.$refs["elForm"].validate(valid => {
        if (valid) {
          this.loadingSubmit = true
          if (this.dialogType === 'CREATE') {
            createCompanyData(this.formStore).then(res => {
              if (res.success) {
                that.showToast({
                  title: '提交成功',
                  h: that
                })
              }
              this.loadingSubmit = false
              this.dialogStore = false
              this.getTableData()
            })
          } else {
            updateCompanyData(this.formStore).then(res => {
              if (res.success) {
                that.showToast({
                  title: '提交成功',
                  h: that
                })
              }
              this.loadingSubmit = false
              this.dialogStore = false
              this.getTableData()
            })
          }
        }
      })
    },
  }
}
</script>

<style lang="scss">
.company-container {
  padding: 20px;
  display: flex;
  background: #f7f8fa;
  min-height: calc(100vh - 104px);
  //overflow: hidden;

  .company-list {
    width: 25%;
    height: calc(100% - 42px);
    margin-right: 40px;
    background: #FFF;
    border-radius: 12px;
    padding: 20px;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .divide-title {
      font-size: 16px;
      font-weight: 600;
      color: #45474d;
      display: flex;
      align-items: center;
      float: left;

      span {
        width: 2px;
        height: 12px;
        background: #fe346e;
        margin-right: 8px;
      }
    }
  }
}
</style>
